module.exports = __webpack_public_path__ + "static/MinuteOfIslands0-938b14cab86867685c882787f3f47c04.webp";